import axios from "../../../../api/axios";

import { NotificationCategoryEnum } from "../../enums/notifications";
import { NotificationsResponse } from "../../types/notification";

export const getNotifications = async (
  offset: number,
  category: NotificationCategoryEnum
): Promise<NotificationsResponse> => {
  try {
    const response = await axios.get<NotificationsResponse>(
      `/users/notifications?limit=10&offset=${offset * 10}&category=${category}`
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const updateLastSeenNotifications = async (body: any) => {
  try {
    const response = await axios.patch(`/users/last-seen-notifications`, body);
    return response;
  } catch (err: any) {
    if (err.response.data.errors) throw new Error(err.response.data.errors);
    throw new Error(err + " Failed in register your entity API");
  }
};

export type LastSeenNotificationsResponse = {
  data: {
    lastSeen: number;
    categoriesLastSeen: {
      [key in NotificationCategoryEnum]: number;
    };
  };
};

export const getLastSeenNotifications = async () => {
  try {
    const response = await axios.get<LastSeenNotificationsResponse>(`/users/last-seen-notifications`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};
